function makeAppConfig() {
  let KA_ENV = "prod"; //local, dev, uat, prod
  let date = new Date();
  let year = date.getFullYear();
  let kaConstant = new KAConstants(KA_ENV);

  let AppConfig = {
    SERVICEDOCURL: kaConstant.SERVICEDOC_URL,
    brand: "Kitchen Aid",
    appUrlBase: kaConstant.BACKEND_API_URL,
    appUrl: kaConstant.BACKEND_API_URL + "/_ah/api",
    google_client_id: kaConstant.GOOGLE_CLIENT_ID,
    salesOrgId: "KAHQ", //'KAFG' for SAP HANA Change
    ESRP_FRONTEND_URL: kaConstant.ESRP_FRONTEND_URL,
    ESRP_BACKEND_URL: kaConstant.ESRP_BACKEND_URL,
    ESRP_API_CALL_Header: kaConstant.ESRP_API_CALL_Header,
    esrpErrorTexts: {
      WPASS_ID_REQ: "Please enter the WPASS ID",
      PASS_REQ: "Please enter the password",
      INVLD_CRDNTLS: "Invalid Credentials",
    },
    toasterDefaultTimeOut: 2000,
    toasterDefaultPositionClass: "toast-bottom-right", // 'toast-top-full-width', 'toast-bottom-full-width', 'toast-center',
    // 'toast-top-left', 'toast-top-center', 'toast-top-right',
    // 'toast-bottom-left', 'toast-bottom-center', 'toast-bottom-right',
    role_ICB: "icb",
    role_WRT: "wrt",
    role_TR: "TRADE_PARTNER",
    role_Admin: "admin",
    toastrType: {
      error: "error",
      info: "info",
      wait: "wait",
      success: "success",
      warning: "warning",
    },
    user: "",
    year: year,
    layoutBoxed: false, // true, false
    navCollapsed: true, // true, false
    navBehind: false, // true, false
    fixedHeader: true, // true, false
    sidebarWidth: "middle", // small, middle, large
    theme: "light", // light, gray, dark
    colorOption: "34", // 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    AutoCloseMobileNav: true, // true, false. Automatically close sidenav on route change (Mobile only)
    productLink: "",
  };

  return AppConfig;
}

export class KAConstants {
  BACKEND_API_URL = "";
  SERVICEDOC_URL = "";
  ESRP_URL = "";
  REPORT_URL: string = "";
  GOOGLE_CLIENT_ID = "";
  ESRP_FRONTEND_URL = "";
  ESRP_BACKEND_URL = "";
  ESRP_API_CALL_Header: any;

  constructor(env: string) {
    let ESRP_ENV =
      env == "local" || env == "dev" || env == "uat" ? "uat" : "prod";
    console.log("******* initializing app constants *******  " + env);
    if (env == "prod") {
      this.BACKEND_API_URL =
        "https://icbservice-dot-kitchenaid-web-return-prod.uc.r.appspot.com";
      //this.BACKEND_API_URL='https://newsapwsdl-dot-icbservice-dot-kitchenaid-web-return-prod.uc.r.appspot.com';
      this.GOOGLE_CLIENT_ID =
        "435650692836-hpk2avk4fk61m78e1q402hsf527ae6c1.apps.googleusercontent.com"; //PROD
      this.SERVICEDOC_URL = "https://ka.documents.whirlpool.com/wiseservice";
      this.ESRP_URL = "https://kitchenaid-esrp-prod.appspot.com";
      this.ESRP_FRONTEND_URL = "https://kitchenaid-esrp-prod.appspot.com";
      this.ESRP_BACKEND_URL =
        "https://backendservice-dot-kitchenaid-esrp-prod.appspot.com";
      this.ESRP_API_CALL_Header = {
        "Content-Type": "application/json",
        "access-token": "kAeYhUjEdZc0crZGH5GkkvdEphgb56Vmo3TVd52MGH",
      };
    } else if (env == "uat") {
      this.BACKEND_API_URL =
        "https://icbservice-dot-kitchenaid-web-return-dev.appspot.com";

      this.GOOGLE_CLIENT_ID =
        "526299230938-s2rdl1gsp4av4utb9roo8id76009jvv3.apps.googleusercontent.com";
      this.SERVICEDOC_URL = "https://qa.ka.documents.whirlpool.com/wiseservice";
      this.ESRP_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_FRONTEND_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_BACKEND_URL =
        "https://backendservice-dot-kitchenaid-esrp-qa.appspot.com";
      this.ESRP_API_CALL_Header = {
        "Content-Type": "application/json",
        "access-token": "kAeYhUjEdZc0crZGH5GkkvdEphgb56Vmo3TVd52MGH",
      };
    } else if (env == "dev") {
      //dev
      //this.BACKEND_API_URL='https://icbservice-dot-kitchenaid-web-return-dev.uc.r.appspot.com';
      this.BACKEND_API_URL =
        "https://icbservice-dot-kitchenaid-web-return-dev.uc.r.appspot.com"; //for local development and testing use only
      this.GOOGLE_CLIENT_ID =
        "526299230938-s2rdl1gsp4av4utb9roo8id76009jvv3.apps.googleusercontent.com";
      this.SERVICEDOC_URL = "https://qa.ka.documents.whirlpool.com/wiseservice";
      this.ESRP_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_FRONTEND_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_BACKEND_URL =
        "https://backendservice-dot-kitchenaid-esrp-qa.appspot.com";
      this.ESRP_API_CALL_Header = {
        "Content-Type": "application/json",
        "access-token": "kAeYhUjEdZc0crZGH5GkkvdEphgb56Vmo3TVd52MGH",
      };
    } else if (env == "local") {
      //local
      this.BACKEND_API_URL = "http://localhost:8080";

      this.GOOGLE_CLIENT_ID =
        "526299230938-s2rdl1gsp4av4utb9roo8id76009jvv3.apps.googleusercontent.com";
      this.SERVICEDOC_URL = "https://qa.ka.documents.whirlpool.com/wiseservice";
      this.ESRP_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_FRONTEND_URL = "https://kitchenaid-esrp-qa.appspot.com";
      this.ESRP_BACKEND_URL =
        "https://backendservice-dot-kitchenaid-esrp-qa.appspot.com";
      this.ESRP_API_CALL_Header = {
        "Content-Type": "application/json",
        "access-token": "kAeYhUjEdZc0crZGH5GkkvdEphgb56Vmo3TVd52MGH",
      };
    }
    console.log("****** done *****");
  }
}
export const APPCONFIG = makeAppConfig();



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/config.ts